import { normalizeWorkspacesForUi } from "app/pages/customers/dsok/utils/normalizeDsokWorkspaces";

/**
 * List all `compressor` devices from a POS workspace document (dsokPosWorkspaces).
 * Used by the concreteStation App-settings selector to pick which compressor is started
 * after a finalized order. Returns rows with the workspace + device identifiers that the
 * backend resolves against (`findWorkspaceByCustomerIdAndWorkspaceId` + `device.uuid`).
 *
 * @param {object} posWorkspaceDoc
 * @returns {{ workspaceId: string, workspaceName: string, deviceId: string, deviceName: string, selectionKey: string }[]}
 */
export function listCompressorDevicesFromPosWorkspaceDoc(posWorkspaceDoc) {
  const { data } = normalizeWorkspacesForUi(posWorkspaceDoc || {});
  const rows = [];
  for (const ws of data || []) {
    if (!ws || typeof ws !== "object") continue;
    const workspaceId =
      ws.uuid != null && String(ws.uuid).trim() !== ""
        ? String(ws.uuid).trim()
        : "";
    if (!workspaceId) continue;
    const workspaceName =
      typeof ws.name === "string" && ws.name.trim() !== ""
        ? ws.name.trim()
        : workspaceId;
    const devices = Array.isArray(ws.devices) ? ws.devices : [];
    for (const d of devices) {
      if (!d || typeof d !== "object") continue;
      if (String(d.type ?? "").trim() !== "compressor") continue;
      const deviceId =
        (d.uuid != null && String(d.uuid).trim() !== ""
          ? String(d.uuid).trim()
          : null) ||
        (d.deviceId != null && String(d.deviceId).trim() !== ""
          ? String(d.deviceId).trim()
          : "");
      if (!deviceId) continue;
      const deviceName =
        typeof d.name === "string" && d.name.trim() !== ""
          ? d.name.trim()
          : deviceId;
      rows.push({
        workspaceId,
        workspaceName,
        deviceId,
        deviceName,
        selectionKey: `${workspaceId}::${deviceId}`,
      });
    }
  }
  return rows;
}
